import React from 'react'

const Quotation = () => {
  return (
    <div>Quotation</div>
  )
}

export default Quotation